<template>
  <v-chip
    v-if="showAtsMenu || showTapwageMenu"
    class="label-chip mr-2 pl-1 mt-auto mb-auto"
    size="small"
  >
    <img
      width="20"
      class="ats-icon mr-1"
      :src="atsIcon || 'https://static.tapwage.com/taprecruit/ats_icons/ats_28.png'"
      :alt="atsName"
    >

    <template #append>
      <DpplSvg
        class="ml-1"
        file-name="icon-chevron-down"
      />
    </template>

    <DocumentAtsMenu />
  </v-chip>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useEditor } from '@/stores/editor/editor';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import DocumentAtsMenu from '@/components/editor/DocumentAtsMenu.vue';

const {
  atsIcon,
  atsName,
  showAtsMenu,
  showTapwageMenu,
} = storeToRefs(useEditor());
</script>

<style scoped lang="less">
.v-chip.label-chip {
  color: fade(@grey-900, 70%);
  cursor: pointer;
}
</style>
